import { FC, useCallback } from 'react';
import { useSelectorWithConfig } from 'shared/hooks';
import { selectMortgagePromoSearchTypeFilter } from 'shared/selectors/advancedFilters/mortgagePromoSearchType';
import { NonEmptyArray } from '../../../../../../../../packages/JsonQuery';
import { SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { usePromoTypeChange } from '../hooks/usePromoTypeChange';

export const SingleMortgageSearchTypeContainer: FC = () => {
  const { value, options } = useSelectorWithConfig(selectMortgagePromoSearchTypeFilter);
  const onChange = usePromoTypeChange();

  /* istanbul ignore next */
  const handleChange = useCallback(
    (newValue: string | null) => {
      const newArrayValue = newValue ? ([newValue] as NonEmptyArray<string>) : null;

      onChange(newArrayValue);
    },
    [onChange],
  );

  return <SingleSelectionAdvancedFilter options={options} value={value} onFilterChange={handleChange} />;
};
